import { Header5, InlineText2 } from '@cian/ui-kit/typography';
import { IconFunctionalSuccess12 } from '@cian/ui-kit-design-tokens/icons';
import { plural } from '@cian/utils';
import React, { memo } from 'react';

import styles from './CoworkingAmenitiesList.css';
import { ICoworkingAmenity } from '../../../types/offer';

interface ICoworkingAmenitiesListProps {
  amenities: ICoworkingAmenity[];
  moreAmenitiesCount?: number;
  url?: string;
}

export const CoworkingAmenitiesListComponent: React.FC<ICoworkingAmenitiesListProps> = ({
  amenities,
  moreAmenitiesCount,
  url,
}) => {
  if (!amenities.length) {
    return null;
  }

  return (
    <div className={styles['root']} data-name="CoworkingAmenitiesListComponent">
      <Header5 as="h5">Включено в стоимость аренды:</Header5>

      <div className={styles['amenities-list']}>
        {amenities.map(({ key, title }) => (
          <div key={key} className={styles['amenity-item']}>
            <IconFunctionalSuccess12 color="accent-positive-primary" />
            <InlineText2>{title}</InlineText2>
          </div>
        ))}

        {!!moreAmenitiesCount && url && (
          <a className={styles['link-to-details']} href={`${url}#amenities`}>
            <InlineText2 color="text-main-default">{`+ ${moreAmenitiesCount} ${plural(moreAmenitiesCount, ['удобство', 'удобства', 'удобств'])}`}</InlineText2>
          </a>
        )}
      </div>
    </div>
  );
};

CoworkingAmenitiesListComponent.displayName = 'CoworkingAmenitiesList';

export const CoworkingAmenitiesList = memo(CoworkingAmenitiesListComponent);
